import { Component, Input } from "@angular/core";

@Component({
  selector: "ngx-card-value-overview",
  styleUrls: ["./card-value-overview.component.scss"],
  templateUrl: "./card-value-overview.component.html",
})
export class CardValueOverviewComponent {
  @Input() type: string;
  @Input() icon?: string;
  @Input() title: string;
  @Input() value: number;
  @Input() quantity?: number;
}
